const FALLBACK = '/'

/**
 * Returns `value` only if it is a same-origin relative path, otherwise `/`.
 * Guards the post-2FA redirect against open redirects and `javascript:` URLs.
 */
export const sanitizeReturnTo = (value: string | null | undefined): string => {
  if (!value || !value.startsWith('/')) return FALLBACK
  // '//host' is protocol-relative; '/\host' is normalised to '//host' by browsers
  if (value.startsWith('//') || value.includes('\\')) return FALLBACK
  // Control characters (tab/newline are stripped by URL parsers: '/\t/host')
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(value)) return FALLBACK
  try {
    const url = new URL(value, window.location.origin)
    if (url.origin !== window.location.origin) return FALLBACK
    const out = url.pathname + url.search + url.hash
    // Dot segments can collapse '/..//host' into '//host': re-check the normalised result
    if (!out.startsWith('/') || out.startsWith('//')) return FALLBACK
    return out
  } catch {
    return FALLBACK
  }
}
